module.exports = __webpack_public_path__ + "img/icon-box.8104b21f.svg";